export default "__VITE_ASSET__rRME1xsa__"